export default "__VITE_ASSET__BTaHuL84__"